import { useEffect, useState } from 'react';
import { getModelKey } from '../services/ModelKeyService';

/**
 * Whether the person has their own model key saved, for a chat that needs it (AI Foundry off, see usePlanFeatures):
 * 'checking', 'saved', or 'missing'. Asks mia-flow-bff (`GET /api/me/model-key`) only while `needed`; a BFF that
 * cannot keep keys, or a failed check, reads as 'missing'. Not needed: 'saved', so nothing waits on it.
 */
export default function useOwnModelKey(needed) {
  const [state, setState] = useState(needed ? 'checking' : 'saved');
  useEffect(() => {
    if (!needed) {
      setState('saved');
      return undefined;
    }
    let cancelled = false;
    setState('checking');
    getModelKey()
      .then((info) => { if (!cancelled) { setState(info?.configured ? 'saved' : 'missing'); } })
      .catch(() => { if (!cancelled) { setState('missing'); } });
    return () => { cancelled = true; };
  }, [needed]);
  return state;
}
